import React from 'react';
import { Button } from 'antd';
import { HostedTableFooterContanier } from './Style';
import { useSelector } from 'react-redux';

const HostedTableFooter = ({ cancelForm, disabled, isEdit, setStep, previewDisabled, showPreview }) => {
  const step = useSelector((state) => state.hostedTables.step);
  const loading = useSelector((state) => state.hostedTables.loading);

  return (
    <HostedTableFooterContanier className="ant-modal-footer">
      {step === 1 && <Button onClick={() => showPreview()} disabled={previewDisabled}>Preview</Button>}
      {(step === 2 || step === 3)  && <Button onClick={() => setStep(1)}>Back</Button>}
      <Button disabled={loading} onClick={cancelForm}>Cancel</Button>
      { step !== 3 && <Button type="primary" htmlType="submit" loading={loading} disabled={disabled}>{(step === 2 || isEdit) ? 'Upload' : 'Next'}</Button> }
    </HostedTableFooterContanier>
  );
};

export default HostedTableFooter;
